import React from "react";
import "./styles.css";
export default function index() {
  return <div className="footer">foot</div>;
}
